import { Info, RefreshCw } from 'lucide-react';
import React, { useState } from 'react';

const PendingSettlement = ({ content, children, position = 'right', width = 'w-44', className = '' }) => {
  const [visible, setVisible] = useState(false);

  if (!content) return children || null;

  const positionClasses = {
    top: {
      tooltip: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
      arrow: '-bottom-1 left-1/2 -translate-x-1/2',
    },
    bottom: {
      tooltip: 'top-full left-1/2 -translate-x-1/2 mt-2',
      arrow: '-top-1 left-1/2 -translate-x-1/2',
    },
    left: {
      tooltip: 'right-full top-1/2 -translate-y-1/2 mr-2',
      arrow: '-right-1 top-1/2 -translate-y-1/2',
    },
    right: {
      tooltip: 'left-full top-1/2 -translate-y-1/2 ml-2',
      arrow: '-left-1 top-1/2 -translate-y-1/2',
    },
  };

  const currentPosition = positionClasses[position] || positionClasses.bottom;

  return (
    <div
      className={`relative flex justify-center items-center ${className} bg-blueHighlight rounded-full`}
      style={{ width: '20px', height: '20px' }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children || <RefreshCw size={12} className="text-white cursor-help" strokeWidth={2.25} />}

      {visible && (
        <div
          className={`
            absolute
            ${currentPosition.tooltip}
            ${width}
            bg-blueDarker
            text-white
            text-xs
            font-normal
            leading-relaxed
            rounded-lg
            px-3
            py-2
            z-50
            shadow-lg
            whitespace-pre-line
          `}
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default PendingSettlement;
